import React, {Component} from 'react';
import PageLayout from './PageLayout';
import EmbeddedWidget from '../widgets/EmbeddedWidget';

export default class EmbeddedWidgetLayout extends Component {
    constructor(props){
        super(props);
    }
    render(){
        const { data, sitemap } = this.props;
        return(
            <PageLayout sitemap={sitemap} >
                {
                    data && (
                        <EmbeddedWidget data={data}/>
                    ) 
                }
            </PageLayout>
        );
    }
};
